import { call, put } from 'redux-saga/effects';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { parseBoardState } from 'utils/whiteboard/parseBoardState';
import { loaderDisplayChanged } from 'features/content-library/contentLibrarySlice';
import {
  contentBoard,
  type ContentBoardData,
} from 'features/content-whiteboard/utils/contentBoardStateManager';

export type InitContentWhiteboardData = Omit<ContentBoardData, 'shapes'> & {
  shapes: string[];
};

interface InitContentWhiteboardOptions {
  readOnly?: boolean;
}

export function* initContentWhiteboardDataSaga(
  data: InitContentWhiteboardData,
  { readOnly = false }: InitContentWhiteboardOptions = {}
) {
  const contentWhiteboardData: ContentBoardData = {
    ...data,
    shapes: [],
  };

  if (data.shapes.length) {
    contentWhiteboardData.shapes = yield call(parseBoardState, data.shapes);
  }

  yield call(contentBoard.init, contentWhiteboardData);

  if (readOnly) {
    yield call(contentBoard.stop);
    yield put(loaderDisplayChanged(false));
    return;
  }

  const canEditWhiteboard: boolean = yield call(hasPermissionsSaga, PermissionTypes.editWhiteboard);

  if (canEditWhiteboard) {
    yield call(contentBoard.watch);
  } else {
    yield call(contentBoard.stop);
  }

  yield put(loaderDisplayChanged(false));
}
